import { StyleSheet } from '@react-pdf/renderer';

import { PDF_STYLES_CONSTANTS } from '../../constants/pdfStylesConstants.ts';

const styles = StyleSheet.create({
  container: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    width: PDF_STYLES_CONSTANTS.DIMENSIONS.CONTENT_WIDTH,
    left: PDF_STYLES_CONSTANTS.DIMENSIONS.LEFT_MARGIN,
    color: PDF_STYLES_CONSTANTS.COLORS.PRIMARY_DARK,
  },
  titleContent: {
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_SMALL,
    paddingBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.NORMAL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.XX_LARGE,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 25,
    paddingBottom: PDF_STYLES_CONSTANTS.SPACING.PADDING_BOTTOM_SMALL,
    flexDirection: 'row',
    borderBottom: '0.5 solid #000',
  },
  reportTitle: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.LARGE,
    textAlign: 'left',
    fontWeight: PDF_STYLES_CONSTANTS.FONT_WEIGHTS.NORMAL,
  },
  headerDescription: {
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.LARGE,
    paddingTop: 15,
    display: 'flex',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
  },
  tableHeader: {
    flexDirection: 'row',
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL_MEDIUM,
    fontWeight: 600,
    paddingTop: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
    paddingBottom: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
  },
  tableRow: {
    flexDirection: 'row',
    borderTop: '1px solid black',
  },
  tableRowBody: {
    flexDirection: 'row',
    paddingTop: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
    paddingBottom: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
    borderBottom: '0.5px solid #CBCBCB',
  },
  cell: {
    textAlign: 'left',
  },
  headerCell: {
    fontWeight: 'bold',
    flex: 1,
  },
  groupHeader: {
    fontWeight: 'bold',
    flex: 1.5,
    paddingTop: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
    paddingBottom: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.SMALL,
  },
  regularCell: {
    flex: PDF_STYLES_CONSTANTS.LAYOUT.FLEX_FULL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.MEDIUM,
    fontFamily: 'STIXTwoMath',
  },
  // Special style for cells containing Unicode symbols
  symbolCell: {
    flex: PDF_STYLES_CONSTANTS.LAYOUT.FLEX_FULL,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.MEDIUM,
    fontFamily: 'STIXTwoMath',
  },
  checkCell: {
    flex: 0.5,
    fontSize: PDF_STYLES_CONSTANTS.FONT_SIZES.MEDIUM,
    textAlign: 'left',
  },
  headerColumn1: {
    flex: 1.5,
  },
  headerColumnOthers: {
    flex: PDF_STYLES_CONSTANTS.LAYOUT.FLEX_FULL,
  },
  headerColumnCheck: {
    flex: 0.5,
  },
  descriptionImage: {
    width: '100%',
  },
  imageContent: {
    padding: PDF_STYLES_CONSTANTS.SPACING.PADDING_TOP_MEDIUM,
  },
});

export default styles;
